module.exports = __webpack_public_path__ + "static/media/wholefoodsLogo.e62a524c.png";